import React from 'react'
import PropTypes from 'prop-types'

import { Image, Flex } from '@chatterbug/aaron'
import { MEDIA_TYPE_VIDEO } from 'src/lib/media'
import AspectRatioImage from 'src/ui/AspectRatioImage/AspectRatioImage'

import playIcon from './assets/play.svg'

const ICONS_MAP = {
  [MEDIA_TYPE_VIDEO]: playIcon,
}

const MediaThumbnail = ({
  type = MEDIA_TYPE_VIDEO,
  altText,
  thumbnailAspectRatio,
  thumbnailUrl,
}) => {
  const icon = ICONS_MAP[type]

  return (
    <AspectRatioImage
      aspectRatio={thumbnailAspectRatio}
      imgUrl={thumbnailUrl}
      altText={altText}
      borderRadius="0,5x"
      sx={{
        position: 'relative',
        cursor: 'pointer',
        ':hover, :active': {
          img: {
            opacity: 0.8,
          },
        },
      }}
    >
      {icon && (
        <Flex
          justifyContent="center"
          alignItems="center"
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
          }}
        >
          <Image src={playIcon} width="30%" alt={type} />
        </Flex>
      )}
    </AspectRatioImage>
  )
}

MediaThumbnail.propTypes = {
  type: PropTypes.oneOf([MEDIA_TYPE_VIDEO]),
  altText: PropTypes.string.isRequired,
  thumbnailUrl: PropTypes.string.isRequired,
  thumbnailAspectRatio: PropTypes.string.isRequired,
}

export default MediaThumbnail
